var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user_settings"},[_c('RadioGroupDiv',{attrs:{"options":_vm.updateTypeOptions},model:{value:(_vm.updateType),callback:function ($$v) {_vm.updateType=$$v},expression:"updateType"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }